
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { constants } from 'fs';


function getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
}
export default {
name: 'foot',
directives: {
TransferDom
},
components: {
Tabbar,
TabbarItem,
Popup,
},

data () {
return {
token: this.$common.getCookie('_token'),
selectedMenu: false,
imgSrc: {
designImg: require('../assets/images/mDesignN.png'),
printImg: require('../assets/images/mPrintN.png'),
customizationImg: require('../assets/images/mCustomizationN.png'),
shopImg: require('../assets/images/mShopN.png'),
personageImg: require('../assets/images/mMineN.png'),
},
activeImgSrc: {
designImg: require('../assets/images/mDesign.png'),
printImg: require('../assets/images/mPrint.png'),
customizationImg: require('../assets/images/mCustomization.png'),
shopImg: require('../assets/images/mShop.png'),
personageImg: require('../assets/images/mMine.png'),
},
activeItem: '',
designPopup:false,
printPopup:false,
customizationPopup:false,
morePopup:false,
printServeShow: false,
}
},

watch: {
$route: {
handler: function (val, oldVal) {
this.token = this.$common.getCookie('_token')

if(val.name == 'homePage') {
this.activeItem = ''
}



if(!val.meta.belong){
val.meta.belong = oldVal.meta.belong

}
this.designPopup = false
this.printPopup = false
this.customizationPopup = false
this.morePopup = false
this.printServeShow = false

},

deep: true
}
},

methods: {
design () {



this.activeItem = 'design'
this.designPopup = true
this.printPopup =false
this.customizationPopup =false
this.morePopup =false
this.printServeShow = false
},
print () {



this.activeItem = 'print'
this.$route.meta.keepAlive = false
this.printPopup = true
this.designPopup = false
this.customizationPopup =false
this.morePopup =false
this.printServeShow = false
},
customization () {



this.activeItem = 'customization'
this.customizationPopup = true
this.printPopup = false
this.designPopup = false
this.morePopup =false
this.printServeShow = false
},
shop () {
this.$router.push({
path: '/shop'
})
this.activeItem = 'shop'
this.customizationPopup = false
this.printPopup = false
this.designPopup = false
this.morePopup =false
this.printServeShow = false

},
personage () {



this.activeItem = 'mine'
this.morePopup = true
this.customizationPopup = false
this.printPopup = false
this.designPopup = false
this.printServeShow = false
},
printServeClick(){
this.printServeShow?this.printServeShow = false :this.printServeShow = true
},
},

created () {

},

mounted () {
console.log(this.$route.meta.belong)
this.activeItem = this.$route.meta.belong

}
}



// WEBPACK FOOTER //
// ./src/components/foot.vue